export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILED = 'LOGIN_FAILED'
export const LOGOUT = 'LOGOUT'
export const TOGGLE_SIDE_BAR = 'TOGGLE_SIDE_BAR'
export const RESERVATIONSTATEMENT = 'RESERVATIONSTATEMENT'
